export default "__VITE_ASSET__BESbHHjJ__"